<template lang="pug">
down-arrow.w-go-down.desktop-only(  v-on='$listeners' )
</template>

<script lang="js">
import DownArrow from '@/components/down-arrow'

export default {
  name: 'GoDownWidget',
  mixins: [],
  components: { DownArrow },
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.w-go-down {
}
</style>
